module.exports = __webpack_public_path__ + "static/img/complete_lynn.1fb8d2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/complete_lynn.jpg
// module id = yKc1
// module chunks = 1